import { useEffect, useRef, useState } from 'react'
import Constants from 'expo-constants'

const POLL_INTERVAL_MS = 5 * 60 * 1000
const SESSION_KEY = 'versionUpdateDismissed'

function getCurrentVersion(): string {
  return Constants.expoConfig?.version ?? ''
}

async function fetchDeployedVersion(): Promise<string | null> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' })
    if (!res.ok) return null
    const data = await res.json() as { version?: string }
    return data.version ?? null
  } catch {
    return null
  }
}

export function useVersionCheck() {
  const currentVersion = getCurrentVersion()
  const [hasUpdate, setHasUpdate] = useState(false)
  const dismissed = useRef(
    typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SESSION_KEY) === 'true',
  )

  useEffect(() => {
    if (!currentVersion || dismissed.current) return

    async function check() {
      const deployed = await fetchDeployedVersion()
      if (deployed && deployed !== currentVersion) {
        setHasUpdate(true)
      }
    }

    void check()
    const timer = setInterval(() => void check(), POLL_INTERVAL_MS)
    return () => clearInterval(timer)
  }, [currentVersion])

  function dismiss() {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(SESSION_KEY, 'true')
    }
    dismissed.current = true
    setHasUpdate(false)
  }

  return { hasUpdate, dismiss }
}
